function _classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}function _defineProperties(target, props) {for (var i = 0; i < props.length; i++) {var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);}}function _createClass(Constructor, protoProps, staticProps) {if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);return Constructor;}import styles from './number-input.component.scss';
import template from './number-input.html';

export var NumberInputComponent = {
  template: template,
  styles: styles,
  require: {
    model: "ngModel" },

  bindings: {},
  controller: /*#__PURE__*/function () {NumberInputComponentController.$inject = ["$element"];
    function NumberInputComponentController($element) {
      "ngInject";_classCallCheck(this, NumberInputComponentController);
      console.log(this);
      this.$element = $element;
    }_createClass(NumberInputComponentController, [{ key: "onChange", value: function onChange()

      {
        return this.model.$setViewValue(this.value);
      } }, { key: "onCountPlus", value: function onCountPlus()

      {
        this.value += 1;
        return this.model.$setViewValue(this.value);
      } }, { key: "onCountMinus", value: function onCountMinus()

      {
        if (this.value > 0) {
          this.value -= 1;
        } else {
          this.value = 0;
        }
        return this.model.$setViewValue(this.value);
      } }, { key: "$onInit", value: function $onInit()

      {var _this = this;
        this.model.$render = function () {
          _this.value = _this.model.$viewValue;
        };
      } }, { key: "$postLink", value: function $postLink()

      {
        this.input = this.$element.find('input')[0];
        angular.element(this.input).on('input keyup keydown', function () {
          return this.value = parseInt(Math.abs(this.value));
        });
      } }]);return NumberInputComponentController;}() };





if (module.hot) module.hot.accept('./number-input.component.scss');